import { FormGroup, FormBuilder } from '@angular/forms';
import { FormPc003Build } from './forms-build/form-pc003-build';

export class FormPc003 extends FormPc003Build {
    public CreateForm(formBuilder: FormBuilder): FormGroup {
        const formulario: FormGroup = formBuilder.group({
            id: [0, []],
            contrato_juridico: ['', []],
            cooperante: ['', []],
            hibrido_rnc: ['', []],
            site_origem: ['', []],
            gleba: ['', []],
            distancia_campo: ['', []],
            especie: ['', []],
            tipo_colheita: ['', []],
            numero_campo: ['', []],
            safra: ['', []],
            ano: ['', []],
            jit: ['', []],
            contrato_torre: ['', []],
            geracao: ['', []],
            origem_contrato: ['', []],
            janela_plantio: ['', []],
            ambiente: ['', []],
            site_recebimento: ['', []],
        });
        return formulario;
    }
}
